import { useGameStore } from '@/store/gameStore'
import { PageShell } from '../components/PageShell'
import { CampusScene } from '../components/campus/CampusScene'
import { ClubStars } from '../components/campus/ClubStars'
import { FacilityCard } from '../components/campus/FacilityCard'
import { DailyActions } from '../components/campus/DailyActions'
import { FACILITY_VISUALS, type CampusSnapshot, type FacilityId } from '@/config/campusConfig'
import { MechanicHint } from '../components/MechanicHint'
import {
  LandPlot, ConciergeBell, ShoppingBag, DoorOpen, Coffee, Home, CarFront, Waves, CircleDot,
  type LucideIcon,
} from 'lucide-react'

const FACILITY_ICONS: Record<FacilityId, LucideIcon> = {
  court: LandPlot,
  reception: ConciergeBell,
  shop: ShoppingBag,
  locker: DoorOpen,
  cafe: Coffee,
  parking: CarFront,
  pool: Waves,
}

export function ClubPage() {
  const clubLevel = useGameStore(s => s.clubLevel)
  const courts = useGameStore(s => s.courts)
  const buildings = useGameStore(s => s.buildings)
  const courtUpgrades = useGameStore(s => s.courtUpgrades)

  const snapshot: CampusSnapshot = { clubLevel, courts, buildings, courtUpgrades }

  return (
    <PageShell
      pageId="club"
      title="Mi Club"
      subtitle={`${courts.length} pistas · ${buildings.length} edificios`}
      icon={<Home size={22} />}
    >
      <div className="space-y-3">
        <CampusScene />

        <ClubStars />

        <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
          <div className="section-label" style={{ marginBottom: 0 }}>Instalaciones</div>
          <MechanicHint
            title="Evolucion de instalaciones"
            bullets={[
              'Cada instalacion sube de tier al mejorarla o ampliarla desde su pestana de gestion.',
              'Mejores instalaciones aumentan la demanda y los ingresos diarios.',
              'El aspecto del club cambia con cada nivel que alcanzas.',
            ]}
          />
        </div>

        <div className="facility-grid">
          {FACILITY_VISUALS.map(visual => (
            <FacilityCard
              key={visual.id}
              visual={visual}
              snapshot={snapshot}
              icon={FACILITY_ICONS[visual.id] ?? CircleDot}
            />
          ))}
        </div>

        <DailyActions />
      </div>
    </PageShell>
  )
}
